export function getTableDateOrWeekday(dateString, getColor = false, getDay = false) {
    if (!dateString) return getColor ? { text: "-", color: "" } : "-";

    const inputDate = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date();
    const yesterday = new Date();

    tomorrow.setDate(today.getDate() + 1);
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (d1, d2) =>
        d1.getDate() === d2.getDate() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getFullYear() === d2.getFullYear();

    let label;
    if (isSameDay(inputDate, today)) {
        label = "Today";
    } else if (isSameDay(inputDate, tomorrow)) {
        label = "Tmrw";
    } else if (isSameDay(inputDate, yesterday)) {
        label = "Yday";
    } else {
        const day = inputDate.getDate();
        let month = inputDate.toLocaleString("default", { month: "short" });
        if (month.toLowerCase() === "sept") month = "Sep";
        const year = inputDate.getFullYear();
        const isCurrentYear = year === today.getFullYear();
        label = isCurrentYear ? `${day}-${month}` : `${day}-${month}-${year % 100}`;
    }

    if (getDay) {
        const dayName = inputDate.toLocaleString("default", { 
            weekday: "short" 
        });
        label = `${label} (${dayName})`;
    }

    if (!getColor) return label;
    
    let color = "";
    if (isSameDay(inputDate, today)) {
        color = "text-sahi-green";
    } else if (inputDate < today) {
        color = "text-sahi-red";
    } else {
        color = "text-sahi-blue";
    }

    return { text: label, color };
}

export const formatTimeAMPM = (dateInput) => {
    if (!dateInput) return "";

    const date = new Date(dateInput);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const hh = String(hours % 12 || 12).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");

    return `${hh}:${mm} ${ampm}`;
};

export const formatDateWithTime = (dateInput) => {
    if (!dateInput) return "-";

    const date = new Date(dateInput);
    const today = new Date();
    const day = date.getDate();
    let month = date.toLocaleString("default", { month: "short" });
    if (month.toLowerCase() === "sept") month = "Sep";
    const year = date.getFullYear();
    const isCurrentYear = year === today.getFullYear();
    const time = formatTimeAMPM(dateInput);
    
    return isCurrentYear ? `${day}-${month} @ ${time}` : `${day}-${month}-${year % 100} @ ${time}`;
};
